module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_c('account-info'), _vm._v(" "), _c('choose-package'), _vm._v(" "), _c('div', {
    staticClass: "declaration"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('declaration')))]), _vm._v(" "), _vm._l((_vm.$t('declarationList')), function(item, index) {
    return _c('p', {
      key: index,
      staticClass: "declaration-list"
    }, [_c('span', {
      staticClass: "index"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v("\n      " + _vm._s(item) + "\n    ")])
  })], 2), _vm._v(" "), _c('pay-status-notice')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e85ed91e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/dashboard/Index.vue
// module id = 1399
// module chunks = 1